import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ASC } from "const"
import { CcRequirement } from "server/models"
import { OrderType } from "client/utils"
import {
    StoreType,
    CcRequirementObjectProps,
    SortCcRequirement,
    DeleteCcRequirementParentChild,
    setCcRequirementParentChild,
    setAssignedCcRequirementChildren,
    addModal,
} from "client/store"
import {
    PageContent,
    Table,
    SortRows,
    DeleteRow,
    Button,
} from "client/components"

import Columns from "./columns"
import NotAssignedChildren from "../notAssigned/children"
import { RequirementParentChildContentWrapper } from "../styled"

const Children = ({
    requirement,
    editAccess,
}: CcRequirementObjectProps) => {
    const requirementList = useSelector((state: StoreType) => state.ccRequirement.requirementList)
    const requirementParentChild = useSelector((state: StoreType) => state.ccRequirement.requirementParentChild)
    const assignedChildren = useSelector((state: StoreType) => state.ccRequirement.assigned.children)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [requirementIds, setRequirementIds] = useState<number[]>([])
    const [sortColumn, setSortColumn] = useState<keyof CcRequirement>("name")
    const [sortOrder, setSortOrder] = useState<OrderType>(ASC)

    useEffect(() => {
        const sortedRequirements = SortCcRequirement(Object.values(requirementList), sortColumn, sortOrder, {})
        const assignedIds = assignedChildren[requirement.id] || []

        const sortedIds: number[] = []
        sortedRequirements.forEach((row) => {
            if (assignedIds.includes(row.id)) sortedIds.push(row.id)
        })
        setRequirementIds(sortedIds)
    }, [requirementList, assignedChildren, sortColumn, sortOrder])

    const onSort: SortRows = (column: keyof CcRequirement, order) => {
        setSortColumn(column)
        setSortOrder(order)
    }

    const onDelete: DeleteRow = (child: CcRequirement, callback) => {
        DeleteCcRequirementParentChild(requirement.id, child.id).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const parentChildFiltered = requirementParentChild.filter((row) => (
                    !(row.parentId === requirement.id && row.childId === child.id)
                ))
                const childIdsFiltered = assignedChildren[requirement.id].filter((id) => id !== child.id)

                dispatch(setCcRequirementParentChild(parentChildFiltered))
                dispatch(setAssignedCcRequirementChildren(requirement.id, childIdsFiltered))
            })
        })
    }

    const columns = Columns(editAccess)
    return (
        <RequirementParentChildContentWrapper>
            <PageContent>
                <Table
                    title={lang.children}
                    columns={columns}
                    dataList={requirementList}
                    dataIds={requirementIds}
                    sortColumn={sortColumn}
                    sortOrder={sortOrder}
                    rowSize="fit"
                    onSort={onSort}
                    onDelete={onDelete}
                    bottomContent={editAccess && (
                        <Button
                            variant="success"
                            onClick={() => dispatch(addModal({
                                key: "addChild",
                                content: <NotAssignedChildren requirement={requirement} />,
                            }))}
                        >
                            {lang.add}
                        </Button>
                    )}
                />
            </PageContent>
        </RequirementParentChildContentWrapper>
    )
}
export default Children
